import GameSprite from "./GameSprite";
import Physics from "./Physics";

class GameAnimation extends GameSprite
{
    constructor(textures)
    {
        super();
        this.textures = textures;
    }


    create()
    {
        this.sprite = new PIXI.Container();
    }


    init()
    {
        this.animation = new PIXI.extras.AnimatedSprite(this.textures);
        this.animation.animationSpeed = 0.15;
        this.animation.loop = false;
        let p = this.entity.getComponent(Physics);

        p.setSpriteRendered(true);

        let projected = this.app.layout.projectGameToScreen(p.position, p.getSize());

        this.animation.x = projected.x;
        this.animation.y = projected.y;
        this.animation.sortZ = (p.position.z * 1000);

        let aspect = this.animation.width / this.animation.height;
        this.animation.height = projected.z;
        this.animation.width = projected.z * aspect;


        this.sprite.addChild(this.animation);

        this.animation.onComplete = this.onAnimationComplete.bind(this);
        this.animation.play();

    }


    postPhysicsUpdate(delta)
    {

    }


    onAnimationComplete()
    {
        this.getEntity().queueForRemoval = true;
    }


    destroy()
    {
        this.textures = null;
        super.destroy();
    }
}

export default GameAnimation